import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans, useTranslation } from '@zurich/common/hooks';
import { useIsDesktop } from '@zurich/ui/hooks';
import { FormFlex, FormFlexItem, Typography, } from '@zurich/ui/legacy/components';
import { useAppImage } from '@zurich/ui/legacy/hooks';
import { styled } from '@zurich/ui/legacy/utils';
import Illustration from '../../images/Illustration_Dryness_RGB.svg';
import { InfoCardLink } from './InfoCard';
export const InfoCardEmptyContent = ({ partyId, simpleView = false, isUsedInClaim, isUsedInOffer, }) => {
    const { t } = useTranslation();
    const AppImage = useAppImage();
    const isDesktop = useIsDesktop();
    const showIllustration = Illustration && isDesktop;
    function renderInfocardTextsAndLinks() {
        if (simpleView) {
            return {
                lnk: _jsx(InfoCardLink, { href: `/party/${partyId}/offer` }),
                text: t('portal:emptyCard.descriptionSimpleViewNoPolicies'),
            };
        }
        return {
            lnk: partyId ? _jsx(InfoCardLink, { href: `/party/${partyId}` }) : _jsx("span", {}),
            text: t(isUsedInOffer
                ? 'portal:emptyCard.descriptionNoOffers'
                : isUsedInClaim
                    ? 'portal:emptyCard.descriptionSimpleViewNoClaims'
                    : 'portal:emptyCard.description'),
        };
    }
    const { text, lnk } = renderInfocardTextsAndLinks();
    return (_jsxs(FormFlex, { rowGap: 0, columnGap: 0, flexWrap: "nowrap", justifyContent: "space-between", align: "center", children: [_jsx(FormFlexItem, { width: showIllustration ? '60%' : '100%', flexGrow: 0, children: _jsxs(TextWrapperStyled, { children: [_jsx(TitleStyled, { children: _jsx(Typography, { variant: "h4", children: t('portal:emptyCard.title') }) }), _jsx(TranslationStyled, { children: _jsx(Trans, { i18nKey: text, components: {
                                    lnk,
                                } }) }), ' '] }) }), showIllustration && (_jsx(FormFlexItem, { width: "40%", children: _jsx(IllustrationContainerStyled, { children: _jsx(IllustrationStyled, { children: _jsx(AppImage, { src: Illustration, alt: t('portal:emptyCard.title') }) }) }) }))] }));
};
const TextWrapperStyled = styled('div')({
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
});
const TitleStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    height: '40%',
    [theme.breakpoints.down('xl')]: {
        paddingBottom: theme.spacing(2),
    },
}));
const IllustrationContainerStyled = styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
}));
const IllustrationStyled = styled('div')({
    position: 'relative', // necessary for AppImages with fill property (if passed as illustration)
    minHeight: '200px',
    width: '100%',
    maxWidth: '336px',
    bottom: 0,
    display: 'table-cell',
    textAlign: 'right',
});
const TranslationStyled = styled('div')({
    whiteSpace: 'pre-wrap',
});
